import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import Preferences from './preferences-model'
import {
  CreatePreferencesAsync,
  DeletePreferencesAsync,
  LoadPreferencessAsync,
} from './preferences-thunk'
const initialState: preferencesSliceState = {
  preferences: [],
  selected_preferences: '',
  is_loading_preferences: false,
  is_creating_preferences: false,
  is_deleting_preferences: false,
}
export interface preferencesSliceState {
  preferences: Preferences[]
  selected_preferences?: string
  is_loading_preferences: boolean
  is_creating_preferences: boolean
  is_deleting_preferences: boolean
}
export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setSelectedpreferences: (state, action) => {
      state.selected_preferences = action.payload
    },
    clearStatepreferences: (state) => {
      state.preferences = []
      state.is_loading_preferences = false
      state.is_creating_preferences = false
      state.is_deleting_preferences = false
    },
    mergepreferences: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_preferences = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.preferences = merge(state.preferences, payload) as any
        }
      }
    },

    add_preferences: (state, action) => {
      if (action.payload) {
        state.preferences = [...state.preferences, action.payload]
      }
    },
    set_preferences: (state, action) => {
      let { key, value, id } = action.payload
      state.preferences = state.preferences.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadPreferencessAsync.pending, (state) => {
      state.is_loading_preferences = true
    })
    builder.addCase(LoadPreferencessAsync.fulfilled, (state, action) => {
      state.is_loading_preferences = false
      if (action.payload) {
        state.preferences = action.payload
      }
    })
    builder.addCase(LoadPreferencessAsync.rejected, (state) => {
      state.is_loading_preferences = false
    })
    builder.addCase(CreatePreferencesAsync.pending, (state) => {
      state.is_creating_preferences = true
    })
    builder.addCase(CreatePreferencesAsync.fulfilled, (state) => {
      state.is_creating_preferences = false
    })
    builder.addCase(CreatePreferencesAsync.rejected, (state) => {
      state.is_creating_preferences = false
    })
    builder.addCase(DeletePreferencesAsync.pending, (state) => {
      state.is_deleting_preferences = true
    })
    builder.addCase(DeletePreferencesAsync.fulfilled, (state, action) => {
      state.is_deleting_preferences = false
      if (state.preferences) {
        state.preferences = state.preferences.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeletePreferencesAsync.rejected, (state) => {
      state.is_deleting_preferences = false
    })
  },
})

export const {
  clearStatepreferences,
  setSelectedpreferences,
  set_preferences,
  mergepreferences,
  add_preferences,
} = preferencesSlice.actions

export const get_preferences =
  (id?: string) =>
  (state: {
    preferences: {
      preferences: Preferences[]
    }
  }): Preferences | null => {
    let temp = state?.preferences?.preferences?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.preferences?.preferences[0] || null
  }
export const get_selected_preferences = (state: {
  preferences: preferencesSliceState
}): Preferences | null => {
  let id = state?.preferences?.selected_preferences
  let temp = state?.preferences?.preferences?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_preferences = (state: {
  preferences: {
    preferences: Preferences[]
  }
}): Preferences[] => {
  let temp = state?.preferences?.preferences
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_preferences_busy = (state: {
  preferences: preferencesSliceState
}) => {
  return (
    state?.preferences.is_deleting_preferences ||
    state?.preferences.is_loading_preferences ||
    state?.preferences.is_creating_preferences
  )
}
export const is_deleting_preferences_busy = (state: {
  preferences: preferencesSliceState
}) => {
  return state?.preferences.is_deleting_preferences
}
export const is_loading_preferences_busy = (state: {
  preferences: preferencesSliceState
}) => {
  return state?.preferences.is_loading_preferences
}
export const is_creating_preferences_busy = (state: {
  preferences: preferencesSliceState
}) => {
  return state?.preferences.is_creating_preferences
}

export default preferencesSlice.reducer
